export default __webpack_public_path__ + "static/media/irongate-logo.7f0380a6.png";